import { ForwardedRef, forwardRef, memo } from 'react'
import classNames from 'classnames'

import css from './Caption.module.scss'

export type CaptionHandle = {
  //
}

export interface CaptionProps {
  className?: string
  children: React.ReactNode
  handleRef?: ForwardedRef<CaptionHandle>
  uppercase?: boolean
  italic?: boolean
  as?: 'span' | 'li'
  useHtml?: boolean
}

export interface ViewProps extends CaptionProps {}

// View (pure and testable component, receives props from the controller)
export const View = forwardRef<HTMLElement, ViewProps>(
  ({ className, children, uppercase = true, italic = false, as = 'span' }, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Tag = as as any

    return (
      <Tag
        className={classNames('Caption', css.root, className, {
          [css.uppercase]: uppercase,
          [css.italic]: italic
        })}
        ref={ref}
      >
        {children}
      </Tag>
    )
  }
)

View.displayName = 'Caption-View'

// Controller (handles global state, router, data fetching, etc. Feeds props to the view component)
const Caption = forwardRef<HTMLElement, CaptionProps>((props, ref) => {
  return <View {...props} ref={ref} />
})

Caption.displayName = 'Caption'

export default memo(Caption)
